import { render, staticRenderFns } from "./TestAudio.vue?vue&type=template&id=adae446c"
import script from "./TestAudio.vue?vue&type=script&lang=ts"
export * from "./TestAudio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports